import { useEffect, useState } from "react";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { SpanRender } from "../../../theme/Component/SpanRender";
import { ViewQuestionItem } from "./ViewQuestionItem";

interface Props {
    question: any;
    response: any;
}
export const ViewQuestion = ({ question, response }: Props) => {

    const UNIQUE = 1;
    const MULTIPLE = 2;
    const BOOLEAN = 3;
    const OPEN = 4;

    const [opciones, setOpciones] = useState<any>();
    const [resp, setResp] = useState<any>({});

    useEffect(() => {
        if (question) {
            setOpciones(question.Options);
        }
    }, [question])

    const setAnswer = (pregunta, resp) => {
        // console.log(resp);
        
        const respuesta = {
            IDTestQuestion: pregunta.IDTestQuestion,
            QuestionType: pregunta.QuestionType,
            OptionResponse: resp
        }
        if (response) {
            response(respuesta);
        }
    }


    return (
        <div className="row">
            <div className="col-md-12 mt-3">
                <h5>
                    <strong><SpanRender value={question.Question} /></strong>
                </h5>
            </div>
            <div className="col-md-12 pl-2">
                <ViewQuestionItem typeQuestion={question.QuestionType} options={question.Options} requireAnswer={question.RequireAnswer} onChange={(e) => { setAnswer(question, e) }} />
                {/* <PrintJson json={question}/> */}
            </div>
        </div>
    )
}